import styled from 'styled-components';

export const Loading = styled.div`
  padding: 40px;
  display: flex;

  > [class^='clap'] {
    margin: 0px auto;
  }
`;
